import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6647eb55"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "signup-view"
}
const _hoisted_2 = { class: "signup-view__container" }
const _hoisted_3 = { class: "d-flex justify-content-between mb-4" }
const _hoisted_4 = { class: "signup-view__logo" }
const _hoisted_5 = { href: "http://www.airsquirrels.com/ditto/" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "signup-view__links d-flex align-items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "signup-view__help-link",
  href: "https://help.airsquirrels.com/ditto",
  target: "_blank",
  rel: "noreferrer noopener"
}, "Help & Support", -1))
const _hoisted_9 = {
  href: "/",
  class: "signup-view__login-button"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "signup-view__heading" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "30-Day Free Trial"),
    /*#__PURE__*/_createElementVNode("p", null, "Set up your Ditto account.")
  ])
], -1))
const _hoisted_11 = { class: "signup-view__form" }
const _hoisted_12 = {
  key: 0,
  class: "text-center bg-danger text-danger"
}
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "row text-center terms-center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("I have reviewed and agree to be bound by the "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "link",
    href: "https://www.airsquirrels.com/ditto/terms",
    target: "_blank",
    rel: "noreferrer noopener"
  }, "Terms and Conditions"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_23 = { class: "row text-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Squirrels needs the contact information you provide to us to alert you about important updates to Ditto and how to best use this product. You may unsubscribe from these communications at any time. For information on how to unsubscribe, as well as our privacy practices and commitment to protecting your privacy, check out our "),
    /*#__PURE__*/_createElementVNode("a", {
      class: "link",
      href: "http://www.airsquirrels.com/privacy-policy/",
      target: "_blank",
      rel: "noreferrer noopener"
    }, "Privacy Policy"),
    /*#__PURE__*/_createTextVNode(".")
  ])
], -1))
const _hoisted_25 = { class: "signup-view__footer" }
const _hoisted_26 = { class: "signup-view__footer-container" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    rel: "noreferrer noopener",
    class: "link",
    href: "http://www.airsquirrels.com/privacy-policy/"
  }, "Privacy Policy")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    rel: "noreferrer noopener",
    class: "link",
    href: "http://www.airsquirrels.com/ditto/contact-sales"
  }, "Contact Us")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_ctx.signupAllowed)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("a", _hoisted_5, [
                _createElementVNode("img", {
                  src: require('../../assets/images/admin-logo-new@2x.png'),
                  class: "signup-view__logo-img"
                }, null, 8, _hoisted_6)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("a", _hoisted_9, [
                _createVNode(_component_el_button, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Log In")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_form, {
              "label-position": "top",
              model: _ctx.newUser,
              rules: _ctx.rules,
              ref: "form"
            }, {
              default: _withCtx(() => [
                (_ctx.errorMessage)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.errorMessage), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_el_form_item, {
                      label: "First Name",
                      prop: "firstName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          placeholder: "Enter first name",
                          modelValue: _ctx.newUser.firstName,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newUser.firstName) = $event)),
                          autocomplete: "offFirstName"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_el_form_item, {
                      label: "Last Name",
                      prop: "lastName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          placeholder: "Enter last name",
                          modelValue: _ctx.newUser.lastName,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newUser.lastName) = $event)),
                          autocomplete: "offLastName"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_el_form_item, {
                      label: "Company",
                      prop: "company"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          placeholder: "Squirrels LLC",
                          modelValue: _ctx.newUser.company,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newUser.company) = $event)),
                          autocomplete: "offCompany"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_el_form_item, {
                      label: "Email",
                      prop: "email"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          placeholder: "Enter email address",
                          modelValue: _ctx.newUser.email,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newUser.email) = $event)),
                          autocomplete: "offEmail"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_el_form_item, {
                      label: "What do you plan to use Ditto for?",
                      prop: "dittoUsage"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          class: "ditto-usage-group d-flex my-2",
                          modelValue: _ctx.newUser.dittoUsage,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newUser.dittoUsage) = $event)),
                          autocomplete: "offDittoUsage"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, { label: "Screen Mirroring" }),
                            _createVNode(_component_el_radio, { label: "Digital Signage" }),
                            _createVNode(_component_el_radio, { label: "Both" })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_el_form_item, { prop: "terms" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.acceptTerms,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.acceptTerms) = $event)),
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_button, {
                      disabled: _ctx.submittingForm,
                      onClick: _ctx.onSubmit,
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Sign Up")
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, "Copyright © " + _toDisplayString(_ctx.dateYear) + ". Squirrels, LLC. All rights reserved.", 1),
              _hoisted_27,
              _hoisted_28
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.viewLoading]
      ])
    : _createCommentVNode("", true)
}